import Icon from '@xo-union/tk-component-icons';
import { Body1, Caption } from '@xo-union/tk-ui-typography';
import React from 'react';
import { useClasses } from '@xo-union/react-css-modules';
import { IconName } from '@xo-union/dist-iconography';
import { Link } from 'react-router-dom';

import LinkButton from '../LinkButton';
import styles from './styles.scss';

interface Props {
  to?: string;
  closeDropdown?: () => void;
  title: string;
  subText?: string;
  icon?: string;
  className?: string;
  classes?: object;
  onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
}

const ButtonDropdownItem: React.FC<Props> = ({
  children,
  to,
  closeDropdown = () => {},
  classes: classesProp,
  icon,
  title,
  subText,
  onClick,
  ...rest
}) => {
  // @ts-ignore
  const classes = useClasses(styles, classesProp);
  const handleClick = () => {
    onClick && onClick();
    closeDropdown();
  };

  const Component = to ? Link : LinkButton;

  return (
    <li tabIndex={0} className={classes.buttonDropdownItem}>
      <Component className={classes.itemLink} to={to as any} onClick={handleClick} color="primary" {...rest}>
        <div className={classes.iconTextContainer}>
          {!!icon && <Icon size="md" name={icon as IconName} />}
          <div className={classes.textContainer}>
            <Body1 className={classes.titleText}>{title}</Body1>
            {!!subText && <Caption className={classes.subText}>{subText}</Caption>}
          </div>
        </div>
      </Component>
    </li>
  );
};

export default ButtonDropdownItem;
